export const loadLocaleData = async (locale) => {
    switch (locale) {
        case 'ar-AE':
            return await import('./ar-AE');
        case 'bg-BG':
            return await import('./bg-BG');
        case 'cs-CZ':
            return await import('./cs-CZ');
        case 'de-DE':
            return await import('./en-US');
        case 'es-ES':
            return await import('./es-ES');
        case 'fr-FR':
            return await import('./fr-FR');
        case 'it-IT':
            return await import('./it-IT');
        case 'ja-JP':
            return await import('./ja-JP');
        case 'ko-KR':
            return await import('./ko-KR');
        case 'pl-PL':
            return await import('./pl-PL');
        case 'pt-BR':
            return await import('./pt-BR');
        case 'ro-RO':
            return await import('./ro-RO');
        case 'ru-RU':
            return await import('./ru-RU');
        case 'th-TH':
            return await import('./th-TH');
        case 'tr-TR':
            return await import('./tr-TR');
        case 'vi-VN':
            return await import('./vi-VN');
        case 'zh-CN':
            return await import('./zh-CN');
        case 'zh-TW':
            return await import('./zh-TW');
        default:
            return await import('./en-US');
    }
};
